import { Box, Button, Grid, Typography, styled, useTheme } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";
import { TransferData } from "assets/Icon";
import useIsMobileView from "hooks/useIsMobileView";

function FormHeader({ sourceCoin, coinMarketDetails, setShowMarketDrawer }) {
  const theme = useTheme();
  const isMobileView = useIsMobileView();

  return (
    <Grid container mb={1}>
      <Grid item xs={4}>
        <ButtonStyle size="small" onClick={() => setShowMarketDrawer(true)}>
          <TransferData color={theme.palette.text.main} />
          <CoinImageWrapper ml={1}>
            <img
              className="behind-img"
              src={DefaultUrlWeb + coinMarketDetails?.coinDestinationImageUrl}
              alt=""
            />

            <img
              className="front-img"
              src={DefaultUrlWeb + coinMarketDetails?.coinSourceImageUrl}
              alt=""
            />
          </CoinImageWrapper>
        </ButtonStyle>
      </Grid>

      <Grid item xs={8} textAlign="right">
        <Box textAlign="center">
          <Typography variant={isMobileView ? "h6" : "h4"} color="text.main">
            {coinMarketDetails?.coinSourceName}/
            <Typography variant={isMobileView ? "h6" : "h5"} component="small">
              {coinMarketDetails?.coinDestinationName}
            </Typography>
          </Typography>

          <Typography variant={isMobileView ? "h6" : "h5"} color="text.main">
            {sourceCoin?.coinName}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

const CoinImageWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "100%",
  minHeight: "45px",

  ".behind-img": {
    top: "0",
    left: "15px",
    position: "absolute",
    borderRadius: "50%",
    width: "27px",
  },
  ".front-img": {
    top: "10px",
    position: "absolute",
    borderRadius: "50%",
    width: "30px",
  },
}));

const ButtonStyle = styled(Button)(({ theme }) => ({
  backgroundColor: "transparent !important",
  "&:hover": {
    backgroundColor: "transparent !important",
  },
}));

export default FormHeader;
